const isDocumentViewerEnabled = () => !window.ReactNativeWebView;

export default isDocumentViewerEnabled;
